import { functionType } from '@/api/chatGPT/chatLog/functions'
import { capitalizeFirstLetter } from '@/helpers/formatting'

export const getUpdateSummary = (type, args, { workflow, svgGraph, svgLanes, cardTypes }) => {
  const event = args.eventId ? svgGraph[args.eventId] : null
  const lane = args.laneId ? svgLanes[args.laneId] : null
  const cardType = args.cardTypeId ? cardTypes.find((item) => item.id === args.cardTypeId) : null
  const entity = args.entityId ? (workflow.dataModels ?? []).find((item) => item.id === args.entityId) : null

  switch (type) {
    case functionType.UPDATE_WORKFLOW_NAME:
      return `Changed workflow name to "${args.name}"`
    case functionType.CREATE_EVENT:
      return `Created new event "${args.description}"`
    case functionType.UPDATE_EVENT_DESCRIPTION:
      return `Updated event description to "${args.description}"`
    case functionType.DELETE_EVENT:
      return `Deleted event "${event?.name ?? ''}"`
    case functionType.CREATE_LANE:
      return `Created new lane "${args.name}"`
    case functionType.UPDATE_LANE_NAME:
      return `Updated lane name to "${args.name}"`
    case functionType.DELETE_LANE:
      return `Deleted lane "${lane?.name ?? ''}"`
    case functionType.MOVE_LANE:
      return `Rearranged lane "${lane?.name ?? ''}"`
    case functionType.CREATE_CARD:
      return `Created new ${cardType?.title ?? ''} card on "${event?.name ?? ''}"`
    case functionType.DELETE_CARD:
      return 'Deleted card'
    case functionType.UPDATE_CARD_DESCRIPTION:
      return `Updated card description to "${args.description}"`
    case functionType.VOTE_CARD:
      return `${capitalizeFirstLetter(args.voteType)}d card.`
    case functionType.CREATE_ENTITY:
      return `Created new entity "${args.name}"`
    case functionType.UPDATE_ENTITY:
      return `Updated entity "${args.name}"`
    case functionType.DELETE_ENTITY:
      return `Deleted entity "${entity?.name ?? ''}"`
    case functionType.CREATE_WRITE_MODEL:
      return `Created new command ${args.name} on event "${event?.name ?? ''}"`
    default:
      return ''
  }
}

export const getUpdatesSummaryText = (updates = []) => {
  if (updates.length === 0) {
    return 'What else can I help you with?'
  }

  const multiple = updates.length > 1
  const header = multiple
    ? 'The following changes are applied to the workflow:\n'
    : ''

  const body = updates
    .map(item => multiple ? `- ${item}` : item)
    .join(multiple ? '\n' : '.\n') +
    (multiple ? '\n' : '.\n')

  const footer = '\nWhat else can I help you with?'

  return header + body + footer
}
